import React from "react";



/*
const Profile = () => {
  

  return (
 
      <></>
  );
};

export default Profile;
*/


const Profile = () => {
 
  return (
   
  
       
      <div>Authentication failed or user data not available</div>
    
  );
};

export default Profile;